const styles = ({ variables }) => ({
  creditBox: {
    position: 'relative',
    background: 'transparent',
    display: 'flex',
    color: variables.colors.primary,
    fill: variables.colors.primary,
    padding: '1em',

    '@media (min-width: 799px)': {
      position: 'absolute',
      background: 'transparent',
      display: 'flex',
      color: '#fff',
      top: '1.2em',
      right: '22em',
      padding: '0 1.5em',
    },
  },
  creditHeader: {
    padding: '0 1em',
    lineHeight: '1.1em',
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'start',
    justifyContent: 'center',
  },
  creditHeaderIcon: {
    extend: 'creditHeader',
    padding: 0,
  },
  creditHeaderButton: {
    display: 'flex',
    border: '1.5px solid #FFFFFF',
    borderRadius: '3px',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 'auto',

    '@media (max-width: 798px)': {
      '& .Button': {
        backgroundColor: 'transparent',
        border: `1.5px solid ${variables.colors.primary}`,
        borderRadius: '3px',
        color: variables.colors.primary,
        padding: '1em',

        '&:hover, &:active &:focus': {
          backgroundColor: variables.colors.primary,
          color: '#fff',
          boxShadow: 'none',
        },
      },
    },
  },
  creditIcon: {
    fill: variables.colors.primary,

    '@media (min-width: 799px)': {
      fill: '#fff',
    },
  },
  total: {
    display: 'block',
    fontWeight: 'bold',
  },
  label: {
    display: 'block',
    fontSize: '0.9em',
  },
});

export default styles;
